import Swiper, {
    Autoplay, Navigation, Thumbs, Pagination, Controller,
} from 'swiper';

Swiper.use([Autoplay, Navigation, Thumbs, Pagination, Controller]);

export default {

    crossLink: () => {
        new Swiper('.swiper', {
            slidesPerView: 'auto',
            loop: true,
            slideClass: 'cmeleon-block-content',
            centeredSlides: false,
            spaceBetween: 20,
            initialSlide: 2,
            edgeSwipeDetection: 'prevent',
        });
    },
};
